export const activeEvents = [
    'click',
    'dblclick',
    'mousedown',
    'mouseup',
    'mouseover',
    'mousemove',
    'mouseout',
    'mouseenter',
    'mouseleave',
    'contextmenu',
    'wheel',
    'scroll'
];

export const focusEvents = [
    'focus',
    'blur',
    'focusin',
    'focusout'
];

export const touchEvents = [
    '+Touch Events',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel'
];

export const keyboardEvents = [
    'keydown',
    'keypress',
    'keyup'
];

export const miscellaneousEvents = [
    'abort',
    'beforeunload',
    'error',
    'hashchange',
    'load',
    'pageshow',
    'pagehide',
    'resize',
    'scroll',
    'unload'
]
